import React from 'react';

const CalendarNavButton = ({ step, label, testId, icon: Icon, onMove }) => (
  <button type="button" className="te-calendar-nav" onClick={() => onMove(step)} aria-label={label} data-testid={testId}>
    <Icon aria-hidden="true" />
  </button>
);

export default CalendarNavButton;
